import { noView } from 'aurelia-framework';
import moment from 'moment';

@noView
export class FromNowValueConverter {
	toView(value) {
		return moment(value).fromNow();
	}
}
